import CryptoJS, {AES, enc} from "crypto-js";

export const EcryptService = {
    getEncrypt(text) {
        const cipherText = AES.encrypt(`${text}`, process.env.REACT_APP_ENCRYPT_KEY);
        return cipherText;
    }
}
